import { bool, string, number, arrayOf, shape } from 'prop-types'

export const groupMemberPersonProps = shape({
  memberCisId: string,
  status: string,
  notifyOnJoin: bool,
  createDate: string,
  contactName: string,
  userProfileName: string,
  portraitUrl: string,
  groupId: string,
  personSharingAccepted: bool,
  recommendedPersonId: string,
})
export const leaderboardPersonProps = shape({
  points: number,
  memberCisId: string,
  status: string,
  notifyOnJoin: bool,
  createDate: string,
  contactName: string,
  userProfileName: string,
  portraitUrl: string,
  personSharingAccepted: bool,
  recommendedPersonId: string,
  groups: arrayOf(
    shape({
      groupId: string,
      treeId: string,
    })
  ),
})
